import { css } from "styled-components";
import {
	colors, devices, fonts,
	maxLinesStyle, bgLinearGradientStyle,
} from "../../../utils/styled";
import { cardContainerStyle } from "./style";

const overlayCardDescriptionStyle = css`
.rel-content__card--overlay__description {
	${maxLinesStyle(15)}
	font-family: ${fonts.AeonikPro};
	opacity: 0;
	max-height: 0;
	margin-top: 0;
	transform: translateY(100%);
	transition: transform .25s ease-out, opacity .25s ease-out, max-height .5s ease-in-out, margin-top .5s ease-out;

	@media ${devices.mobileAndTablet} {
		${maxLinesStyle(4)}
	}

	> p {
		color: ${colors.white};
	}
}
`

const overlayCardHoverStyle = css`
&:hover {
	&:before {
		opacity: 1;
	}
	.rel-content__card--overlay__slider {
		.rel-content__card--overlay__body {
			opacity: 1;
			.rel-content__card--overlay__title {
				h3 {
				}
			}
			.rel-content__card--overlay__description {
				opacity: 1;
				max-height: 1000px;
				margin-top: 12px;
				transform: translateY(0);
				@media ${devices.mobileAndTablet} {
					${maxLinesStyle(5)}
				}
			}
			.rel-content__card--overlay__link {
			}
		}
	}
	.rel-content__card--overlay__bgimg {
		&:before {
			background-color: ${colors.bluegray};
			opacity: 0.9;
		}
	}
}
`

export const overlayCardStyle = css`
	.rel-content__card--overlay {
		${cardContainerStyle}
		border-radius: 24px;
		flex: 1;

		@media ${devices.mobile} {
			border-radius: 10px;
		}

		${overlayCardHoverStyle}

		.rel-content__card--overlay__bgimg {
			height: 835px;

			@media ${devices.mobileAndTablet} {
				height: 450px;
			}

			img {
				width: 100%;
				height: 100%;
				object-fit: cover;
			}

			&:before {
				content: "";
				display: block;
				position: absolute;
				top: 0;
				bottom: 0;
				left: 0;
				right: 0;
				transition: all 0.5s ease-out;
				${bgLinearGradientStyle(colors.bluegray)('both')}
			}
		}

		.rel-content__card--overlay__slider {
			position: absolute;
			top: 16px;
			bottom: 16px;
			left: 16px;
			right: 16px;
			display: flex;
			flex-direction: column;
			justify-content: space-between;
			z-index: 2;

			${overlayCardDescriptionStyle}

			.rel-content__card--overlay__header {
				display: flex;
				position: relative;
				align-items: center;

				.rel-content__card__readingtime {
					display: flex;
					align-items: center;
					margin-left: auto;
					gap: 8px;
					font-family: ${fonts.AeonikMono};
					font-size: 14px;
					svg {
						width: 16px;
						height: 16px;
					}
				}

				.rel-content__card--overlay__tag {
					display: flex;
					align-items: center;
					padding: 11px 10px;
					border-radius: 26px;
					line-height: 100%;
					margin-right: 12px;
					border: 1.75px solid ${colors.lemon};
					color: ${colors.lemon};
					font-size: 12px;
					font-family: ${fonts.AeonikMono};
					line-height: 50%;
					transition: background 300ms ease;
					letter-spacing: 0.5px;
					max-height: 24px;

					&:hover {
						background: rgba(255, 255, 255, 0.1);
					}
				}

				span {
					color: ${colors.white};
				}
			}

			.rel-content__card--overlay__body {
				opacity: 0;
				transition: opacity 0.5s ease-in-out;

				.rel-content__card--overlay__date {
					color: ${colors.lemon};
					font-family: ${fonts.AeonikMono};
					font-size: 30px;
					line-height: 120%;
					letter-spacing: 0.9px;
				}

				.rel-content__card--overlay__title {
					h3 {
						color: ${colors.white};
						font-family: ${fonts.AeonikPro};
						font-size: 40px;
						line-height: 110%;
						letter-spacing: -0.8px;
						font-weight: normal;
						${maxLinesStyle(5)}
						@media ${devices.mobileAndTablet} {
							font-size: 26px;
							${maxLinesStyle(3)}
						}
					}
				}
			}

			.rel-content__card--overlay__link {
				width: min-content;
				white-space: nowrap;
				margin-top: 24px;
				padding: 14px 24px;
				border-radius: 26px;
				text-align: center;
				line-height: 80%;
				font-size: 12px;
				font-family: ${fonts.AeonikMono};
				background-color: ${colors.white};
				color:	${colors.infiosGray};
				transition: background-color 250ms ease-out;
				display: flex;
				gap: 10px;
				align-items: center;
				svg{
					transition: transform 200ms ease
				}
				&:hover {
					background-color: ${colors.lemon};
					svg{
						transform: translateX(2px);
					}
				}
			}
		}
	}
`
